import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from '../../../actions/authentication/requestAuthentication';
import { canUserCreateRequestAction } from '../../../actions/requestButton/canUserCreateRequest';
import { selectRequestFormRequiresAuth } from '../../../selectors/requestForm';
import { TThunkDispatch } from '../../../types/redux/thunk';

interface IParams {
  openRequestFormModal: () => void;
  openRequestExistsModal: () => void;
}

export function useRequestButtonClickHandler({ openRequestFormModal, openRequestExistsModal }: IParams) {
  const dispatch: TThunkDispatch = useDispatch();

  const requestFormRequiresAuth = useSelector(selectRequestFormRequiresAuth);

  const openModalWithCheck = React.useCallback(async () => {
    try {
      const canUserCreateRequest = await dispatch(canUserCreateRequestAction());

      if (canUserCreateRequest) {
        openRequestFormModal();
      } else {
        openRequestExistsModal();
      }
    } catch {
      // Обработано в thunk-е.
    }
  }, [dispatch, openRequestFormModal, openRequestExistsModal]);

  const requestButtonClickHandler = React.useCallback(() => {
    if (requestFormRequiresAuth) {
      dispatch(
        requestAuthentication({
          onSuccess: async () => {
            await openModalWithCheck();
          },
        }),
      );
    } else {
      openModalWithCheck();
    }
  }, [dispatch, requestFormRequiresAuth, openModalWithCheck]);

  return requestButtonClickHandler;
}
